import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';
import { PageLoader } from '@/widgets/page';

export const TermsOfServicePage = withSuspense(
	lazy(async () => await import('./terms-of-service-page.component')),
	PageLoader,
);
